import { RootState } from 'app/store';

export const selectProfile = (state: RootState) => state.userProfile.profile;
export const selectIsLoadingProfile = (state: RootState) =>
  state.userProfile.isLoadingProfile;
